var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.likeList)?_c('div',{staticClass:"likeList"},[_c('ul',_vm._l((_vm.datas),function(item){return _c('li',{key:item.id},[(item.avatar)?_c('img',{staticClass:"portrait",attrs:{"src":item.avatar}}):_vm._e(),(!item.avatar)?_c('img',{attrs:{"src":require("@/assets/add-red.png")},on:{"click":_vm.dianzan}}):_vm._e()])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }